import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {

  transform(value: any[], field?: string): number {
    if (!Array.isArray(value)) return 0;

    // If field is provided, sum the field values
    if (field) {
      return value.reduce((acc, item) => acc + (Number(item[field]) || 0), 0);
    }

    // Otherwise sum the array directly
    return value.reduce((acc, item) => acc + (Number(item) || 0), 0);
  }
}
